import { render } from "./individual-blog-post.vue?vue&type=template&id=b3d21a7a"
import script from "./individual-blog-post.vue?vue&type=script&lang=js"
export * from "./individual-blog-post.vue?vue&type=script&lang=js"

import "./individual-blog-post.vue?vue&type=style&index=0&id=b3d21a7a&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__